import { FC } from 'react';

import { Outlet } from 'react-router-dom';

import { CourtesyGateNotice } from './CourtesyGateNotice';
import { CourtesyOutletContext, useCourtesyAccess } from '../hooks/useCourtesyAccess';

/**
 * 답례인사(courtesy) 페이지들을 감싸는 레이아웃 라우트 게이트.
 * - 부고 없음(404) → 링크 안내
 * - 부고 정리됨 "그리고" 발인 후 60일 초과 → 개인정보 비노출(anonymous) 모드로 렌더
 * - 그 외 → 평소대로 렌더
 *
 * 답례인사는 막지 않는다. 수신자 개인정보가 없는 "생성기"라 기간이 지나도
 * 상주가 감사 인사를 전할 수 있어야 하고, 대신 고인·상주 정보만 감춘다.
 *
 * 로딩 중에도 children을 막지 않는다. 하위 페이지는 부고가 success가 되기 전엔
 * 자체 Loading만 그리므로(개인정보 렌더 없음), 여기서 붙잡으면 하위의
 * courtesyAsset/courtesyContent 조회만 bugo 응답 뒤로 밀려 직렬화된다.
 * 부고가 success가 되는 렌더에서 anonymous도 같은 atom에서 확정되므로 깜빡임도 없다.
 *
 * 부고 조회는 상위 BugoMemberIdRouter가 이미 수행하므로 여기서 재조회하지 않는다.
 */
const CourtesyAccessGate: FC<{ memberId: string }> = function CourtesyAccessGate({
  memberId,
}) {
  const { access } = useCourtesyAccess(memberId);

  if (access === 'invalid') {
    return <CourtesyGateNotice />;
  }

  const context: CourtesyOutletContext = { anonymous: access === 'anonymous' };
  return <Outlet context={context} />;
};

export default CourtesyAccessGate;
